export default __webpack_public_path__ + "static/hyperwave_AST_SLOW-f3c9baedfbab774d9061a7d6f3903dce.mp4";